export default __webpack_public_path__ + "static/media/union-pay.e4513d6d.svg";